import {App} from '@/app/components/desktop/app';
import {initialize} from './client';

(async () => {
	const {rerender} = await initialize('desktop', App);

	if (module.hot) {
		module.hot.accept('@/app/components/desktop/app', () => {
			rerender(App);
		});
	}
})();
